const getDefaultFilters = () => ({
  page: 1,
  itemsPerPage: 25,
  order: { username: 'asc' },
  onboardingBVDisplay: true
})

const getPresetFilters = () => ({
})

export default {
  namespaced: true,
  state: {
    filters: getDefaultFilters(),
    results: { total: -1, list: [] }, // Stockage des derniers résultats pour accélérer le retour arrière
    availableRoles: [{ value: 'ROLE_SUB_ADMIN', label: 'users.admin' },
      { value: 'ROLE_SUB_USER', label: 'users.user' },
      { value: 'ROLE_CONTACT', label: 'users.contact' }
    ],
    selectableRoles: [{ value: 'ROLE_SUB_ADMIN', label: 'users.admin' },
      { value: 'ROLE_SUB_USER', label: 'users.user' }
    ],
    onboardingBVDisplay: true,
    facebookData: {}
  },
  getters: {
    getAvailableRoles: (state) => {
      return state.availableRoles
    },
    getSelectableRoles: (state) => {
      return state.selectableRoles
    },
    getOnBoardingBVDisplay: (state) => {
      return state.onboardingBVDisplay
    },
    getFormattedRole: (state) => (user) => {
      if (user.mainAccount) {
        return 'users.mainAccount'
      }

      let result = null

      state.availableRoles.forEach(function (role) {
        if (user.roles.includes(role.value)) {
          result = role.label
        }
      }, user, result)

      if (!result) {
        return 'users.contact'
      }

      return result
    },
    /** Utilisé par ApiSearchForm (sauvegarde filtres / tri) — pas de tri catalogue sur cette page */
    getSort: () => null
  },
  mutations: {
    setPage (state, page) {
      state.filters = { ...state.filters, page }
    },
    setItemsPerPage (state, itemsPerPage) {
      state.filters = { ...state.filters, itemsPerPage, page: 1 }
    },
    setOffset (state, offset) {
      state.filters = { ...state.filters, offset, page: 1 }
    },
    setOrder (state, order) {
      state.filters = { ...state.filters, order, page: 1 }
    },
    addFilter (state, filter) {
      state.filters = { ...state.filters, ...filter, page: 1 }
      Object.keys(state.filters).forEach(key => {
        if (state.filters[key] === undefined) {
          delete state.filters[key]
        }
      })
    },
    replaceFilter (state, filter) {
      state.filters = { ...getDefaultFilters(), ...filter, page: 1 }
      Object.keys(state.filters).forEach(key => {
        if (state.filters[key] === undefined) {
          delete state.filters[key]
        }
      })
    },
    setFilters (state, filters) {
      state.filters = {
        ...getDefaultFilters(),
        advanced: state.filters.advanced,
        ...filters
      }
    },
    resetFilters (state) {
      state.filters = getDefaultFilters()
      state.results = { total: -1, list: [] }
    },
    resetPresetFilters (state) {
      state.filter = {
        ...getDefaultFilters(),
        ...getPresetFilters()
      }
    },
    setResults (state, results) {
      state.results = results
    },
    setOnboardingBVDisplay (state, result) {
      state.onboardingBVDisplay = result
    }
  }
}
